import { CommonModule } from "@angular/common";
import { Component, Input, model, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, Validators } from "@angular/forms";
import { CheckboxModule } from "primeng/checkbox";

export interface IPersonDetails {
  firstName: string,
  lastName: string,
  emailAddress: string,
  mobilePhone: string,
  homePhone: string
}

@Component({
  selector: "app-order-setup-plan",
  standalone: true,
  imports: [CheckboxModule, CommonModule, FormsModule],
  templateUrl: "./setup-plan.component.html",
  styleUrl: "./setup-plan.component.scss",
  encapsulation: ViewEncapsulation.None,
})
export class OrderSetupPlanComponent implements OnInit {

  constructor(public fb:FormBuilder) {
    
  }
  ngOnInit(): void {
    this.formData = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      emailAddress: ['', Validators.required],
      mobilePhone: ['', Validators.required],
      homePhone: [''],
    });
  }
    personalDetails = model.required<IPersonDetails>();
    termsAccepted = model<boolean>(false);
    formData!: FormGroup;
  
    @Input() activateCallback!: (step: number) => void;
    goToPrevStep(data:number) {
    if (this.activateCallback) {
      this.activateCallback(data); // Example usage of the function
    }
  }
}
